// extracted by mini-css-extract-plugin
export var center = "_5h-2";
export var clickableRow = "_5h-5";
export var expandedRow = "_5h-7";
export var hoverable = "_5h-4";
export var left = "_5h-1";
export var right = "_5h-3";
export var row = "_5h-0";
export var selectedRow = "_5h-6";
export var summaryRow = "_5h-8";